import React from "react";
import { Link } from "react-router-dom";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Header from "../../components/Header/Header";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { yupResolver } from "@hookform/resolvers/yup";

import { availableRegions, registerSchema } from "../../constant";
import { hooks } from "../../studentportal-sdk";
import { useForm, Controller } from "react-hook-form";
import SideBar from "../../components/SideBar/AdminSideBar";

const AddUser = (props) => {
  // const [user, setUser] = useState({
  //   firstname: "",
  //   lastname: "",
  //   email: "",
  //   gender: "",
  //   group: "",
  //   dateofbirth: "",
  //   category: "",
  //   isBaptised: "",
  //   role: "",
  //   phone: "",
  //   address: "",
  //   password: "",
  // });

  const {
    authService: {
      action: { userAccountSignUp },
    },
    utilityAndConfigService: {
      store: { loading },
    },
  } = props;

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registerSchema),
  });

  const onSubmit = (data) => {
    if (data) {
      // setUser({ ...user, ...data });
      userAccountSignUp(data);
    }
  };

  const role = localStorage.getItem("role");
  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        {role === "admin" && <SideBar />}

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-sm-12">
                  <div className="page-sub-header">
                    <h3 className="page-title">Add Admin</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/users">Users</Link>
                      </li>
                      <li className="breadcrumb-item active">Add Admin</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card comman-shadow">
                  <div className="card-body">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                        <div className="col-12">
                          <h5 className="form-title student-info">
                            User Information{" "}
                            <span>
                              <Link to="#">
                                <i className="feather-more-vertical">
                                  <FeatherIcon icon="more-vertical" />
                                </i>
                              </Link>
                            </span>
                          </h5>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>
                              First Name <span className="login-danger">*</span>
                            </label>
                            <Controller
                              name="firstname"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    className={`form-control  ${
                                      errors?.firstname ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    placeholder="Enter your first name"
                                    onChange={onChange}
                                    autoComplete="false"
                                  />
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.firstname?.message}</small>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>
                              Last Name <span className="login-danger">*</span>
                            </label>
                            <Controller
                              name="lastname"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    className={`form-control  ${
                                      errors?.lastname ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    placeholder="Enter your last name"
                                    onChange={onChange}
                                    autoComplete="false"
                                  />
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.lastname?.message}</small>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>
                              Leadership Category{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <Controller
                              name="category"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <select
                                    className={`form-control ${
                                      errors?.category ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                  >
                                    <option className="form-control" value="">
                                      Select Category
                                    </option>
                                    <option
                                      className="form-control"
                                      value="Cell Leader"
                                    >
                                      Cell Leader
                                    </option>
                                    <option
                                      className="form-control"
                                      value="Code Rabah Cell Leader"
                                    >
                                      Code Rabah Cell Leader
                                    </option>
                                    <option
                                      className="form-control"
                                      value="Bible Study Class Teacher"
                                    >
                                      Bible Study Class Teacher
                                    </option>
                                    <option
                                      className="form-control"
                                      value="PCF Leader"
                                    >
                                      PCF Leader
                                    </option>
                                    <option
                                      className="form-control"
                                      value="Group Pastor"
                                    >
                                      Group Pastor
                                    </option>
                                    <option
                                      className="form-control"
                                      value="Graduate Pastor"
                                    >
                                      Graduate Pastor
                                    </option>
                                    <option
                                      className="form-control"
                                      value="Church Pastor"
                                    >
                                      Church Pastor
                                    </option>
                                    <option
                                      className="form-control"
                                      value="Senior Cell Leader"
                                    >
                                      Senior Cell Leader
                                    </option>
                                    <option
                                      className="form-control"
                                      value="Deaconry"
                                    >
                                      Deaconry
                                    </option>
                                  </select>
                                  <span className="profile-views">
                                    <i className="fas fa-users" />
                                  </span>
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.category?.message}</small>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>
                              Group <span className="login-danger">*</span>
                            </label>
                            <Controller
                              name="group"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <select
                                    className={`form-control ${
                                      errors?.category ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                  >
                                    <option className="form-control" value="">
                                      Select Group
                                    </option>
                                    {availableRegions.map((region) => (
                                      <option
                                        className="form-control"
                                        value={region}
                                      >
                                        {region}
                                      </option>
                                    ))}
                                  </select>
                                  {/* <input
                                    className={`form-control  ${
                                      errors?.title ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    placeholder="Enter your group name"
                                    onChange={onChange}
                                    autoComplete="false"
                                  /> */}
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.group?.message}</small>
                          </div>
                        </div>

                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>
                              Email <span className="login-danger">*</span>
                            </label>{" "}
                            <Controller
                              name="email"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    className={`form-control  ${
                                      errors?.email ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    placeholder="Enter your email"
                                    onChange={onChange}
                                    autoComplete="false"
                                  />
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.email?.message}</small>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>Phone Number</label>
                            <Controller
                              name="phone"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    className={`form-control  ${
                                      errors?.phone ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    placeholder="Enter your phone number"
                                    onChange={onChange}
                                    autoComplete="false"
                                  />
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.phone?.message}</small>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>Password </label>
                            <Controller
                              name="password"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    className={`form-control  ${
                                      errors?.password ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    placeholder="Enter your password"
                                    onChange={onChange}
                                    autoComplete="false"
                                  />
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.password?.message}</small>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>Confirm Password </label>
                            <Controller
                              name="confirmPassword"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    className={`form-control  ${
                                      errors?.confirmPassword
                                        ? "error-input"
                                        : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    placeholder="Confirm your password"
                                    onChange={onChange}
                                    autoComplete="false"
                                  />
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.confirmPassword?.message}</small>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                           <div className="form-group local-forms">
                            <label>
                              Have you been baptised?{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <Controller
                              name="isBaptised"
                              control={control}
                              defaultValue="" // Default value for the Controller
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <select
                                    className="form-control"
                                    value={value}
                                    onChange={onChange}
                                  >
                                    <option value="" disabled>
                                      Select an option
                                    </option>
                                    <option value={true}>Yes</option>
                                    <option value={false}>No</option>
                                  </select>
                                  <span className="profile-views">
                                    <i className="fas fa-users" />
                                  </span>
                                </>
                              )}
                            />
                            {errors?.isBaptised && (
                              <small className="text-danger">
                                {errors.isBaptised.message}
                              </small>
                            )}
                          </div>
                        </div>

                        {/* <div className="col-12 col-sm-4">
                          <div className="form-group students-up-files">
                            <label>Upload User Photo (150px X 150px)</label>
                            <div className="upload">
                              <label className="file-upload image-upbtn mb-0">
                                Choose File <input type="file" />
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <div className="col-12">
                          <div className="student-submit">
                            <button
                              type="submit"
                              disabled={loading.active}
                              className="btn btn-primary btn-block"
                            >
                              {!loading.active && "Submit"}
                              {loading.active &&
                                loading.internalLoading &&
                                ".....loading"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

/* eslint-disable */
export default (props) => <AddUser {...hooks.UserManagement(props)} />;
